import { useSwrNoAuth } from "../../swr/useSwrNoAuth";


export const useFetchLiffUrlCustomerByRestaurantId = (restaurantId?: string, liffType?: string) => {
  const fetcherKey = restaurantId ? `external_api/restaurants/${restaurantId}/liff-restaurants/${liffType}/liff-url/customer/` : null;
  const { data: liffUrl, error, isLoading } = useSwrNoAuth<string>(fetcherKey)
  return { liffUrl, isLoading, error };
};